import styled from "@emotion/styled";
import { colors } from "goi_common";

export const DefaultPageContainer = styled.div`
  padding: 24px 20px;
  color: ${colors.white};
`;
